import { Link } from "react-router-dom";

export type Crumb = { name: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs md:text-sm">
      <ol className="flex flex-wrap items-center gap-2 text-foreground-600">
        {items.map((item, index) => (
          <li key={`${item.name}-${index}`} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-900">{item.name}</span>
            )}
            {index < items.length - 1 && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}